import { useCallback, useRef, useState } from 'react';

const SLIDE_BACK = 'transform 0.5s cubic-bezier(0.32, 0.72, 0, 1)';

export const useDiscardGuard = (
  confirmClose: boolean | undefined,
  setOpen: (open: boolean) => void,
) => {
  const [asking, setAsking] = useState(false);
  const contentRef = useRef<HTMLElement | null>(null);

  const onOpenChange = (open: boolean) => {
    if (!open && confirmClose) {
      setAsking(true);
      return;
    }
    setOpen(open);
  };

  const keep = () => {
    setAsking(false);
    const content = contentRef.current;
    if (!content) return;
    content.style.transition = SLIDE_BACK;
    content.style.transform = 'translate3d(0, 0, 0)';
    const overlay = content.previousElementSibling as HTMLElement | null;
    if (overlay?.hasAttribute('data-vaul-overlay')) overlay.style.opacity = '1';
  };

  const discard = () => {
    setAsking(false);
    setOpen(false);
  };

  const setContentRef = useCallback(
    (
      forwarded:
        | ((node: HTMLDivElement | null) => void)
        | { current: HTMLDivElement | null }
        | null,
    ) =>
      (node: HTMLDivElement | null) => {
        contentRef.current = node;
        if (typeof forwarded === 'function') forwarded(node);
        else if (forwarded) forwarded.current = node;
      },
    [],
  );

  return { onOpenChange, asking, keep, discard, setContentRef };
};
